import * as React from 'react'

const Title = ({ children, isLarger = false }) => {
  let className = 'text-5xl font-black leading-tight mb-6'

  if (isLarger) {
    className += ' xl:text-6xl'
  }

  return <h1 className={className}>{children}</h1>
}

export default Title
